import CustomGlobal from "./Input";


export default function ComponentsOverrides(theme) {
  return Object.assign(CustomGlobal(theme));
}
